/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.booking', ['data.employee']);